<template>
    <header class="pw-header">
        <div class="pw-header-glow"></div>

        <nav class="pw-nav container">
            <button class="pw-logo" @click="$router.push('/')">
                <span class="pw-logo-mark">&lt;/&gt;</span>
                <div class="pw-logo-text">
                    <span>Prado's</span>
                    <small>Desenvolvimento Web</small>
                </div>
            </button>

            <ul class="pw-menu">
                <li v-for="link in links" :key="link.to">
                    <router-link :to="link.to" class="pw-link" :class="{ 'is-active': $route.path === link.to }">
                        {{ link.label }}
                    </router-link>
                </li>
            </ul>
        </nav>
    </header>
</template>

<script>
export default {
    name: "HeaderComponent",
    data() {
        return {
            links: [
                { to: "/", label: "Home"},
                { to: "/sobre", label: "Sobre"},
                { to: "/projetos", label: "Projetos"},
                { to: "/contato", label: "Contato"},
            ],
        };
    },
};
</script>

<style scoped>
.pw-header {
    position: sticky;
    top: 0;
    z-index: 50;
    backdrop-filter: blur(22px);
    background: linear-gradient(
        to bottom,
        rgba(15, 23, 42, 0.95),
        rgba(15, 23, 42, 0.78),
        transparent
    );
    border-bottom: 1px solid rgba(148, 163, 184, 0.25);
}

.pw-header-glow {
    position: absolute;
    inset: 0;
    pointer-events: none;
    background: 
        radial-gradient(circle at 0% 0% rgba(34, 211, 238, 0.22), transparent 55%),
        radial-gradient(circle at 100% 0% rgba(139, 92, 246, 0.24), transparent 60%);
    opacity: 0.9;
    mix-blend-mode: screen;
}

.pw-nav {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.9rem 0;
}

/* Logo */
.pw-logo {
    display: inline-flex;
    align-items: center;
    gap: 0.55rem;
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    color: inherit;
}

.pw-logo-mark {
    width: 36px;
    height: 36px;
    border-radius: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: 
        radial-gradient(circle at 0 0, rgba(34, 211, 238, 0.7), transparent 60%),
        radial-gradient(circle at 100% 100%, rgba(139, 92, 246, 0.9), transparent 70%);
    box-shadow: 
        0 0 20px rgba(34, 211, 238, 0.6),
        0 0 28px rgba(139,92, 246, 0.7);
    font-size: 0.95rem;
    font-weight: 600;
    letter-spacing: 0.06em;
}

.pw-logo-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.pw-logo-text span {
    font-size: 1rem;
    font-weight: 600;
    letter-spacing: 0.04em;
}

.pw-logo-text small {
    font-size: 0.7rem;
    text-transform: uppercase;
    letter-spacing: 0.22em;
    opacity: 0.7;
}

/* Menu */
.pw-menu {
    list-style: none;
    display: flex;
    gap: 1.9rem;
    margin: 0;
    padding: 0;
}

.pw-link {
    position: relative;
    font-size: 0.9rem;
    text-decoration: none;
    text-transform: uppercase;
    letter-spacing: 0.14em;
    color: rgba(226, 232, 240, 0.8);
    padding-bottom: 0.3rem;
    transition: 
        color 0.18s ease-out,
        opacity 0.18s ease-out;
}

.pw-link::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    height: 2px;
    width: 0;
    background: linear-gradient(to right, #22d3ee, #8b5cf6);
    box-shadow: 0 0 18px rgba(56, 189, 248, 0.8);
    transition: width 0.22s ease-out;
}

.pw-link:hover {
    color: #e5e7eb;
}

.pw-link:hover::after {
    width: 100%;
}

.pw-link.is-active {
    color: #f9fafb;
}

.pw-link.is-active::after {
    width: 100%;
}

/* Responsivo */
@media (max-width: 768px) {
    .pw-nav {
        padding: 0.7rem 0;
    }

    .pw-menu {
        gap: 1.1rem;
    }

    .pw-link {
        font-size: 0.78rem;
        letter-spacing: 0.12;
    }

    .pw-logo-mark {
        width: 32px;
        height: 32px;
        border-radius: 12px;
    }

    .pw-logo-text span {
        font-size: 0.9rem;
    }

    .pw-logo-text small {
        display: none;
    }
}
</style>